import { render, staticRenderFns } from "./ShipmentViewPopup.vue?vue&type=template&id=ecd6b1cc&"
import script from "./ShipmentViewPopup.vue?vue&type=script&lang=js&"
export * from "./ShipmentViewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports